import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  memberDetailActions,
  selectConnectUserTypeLoading,
} from 'features/member/reducer/memberDetailSlice';

import StatusDropdown from 'components/memberdetail/detail/connect/connectinformation/StatusDropdown';
import Checkbox from 'components/common/form/Checkbox';
import CheckboxGroup from 'components/common/form/CheckboxGroup';
import { CommonSpinner } from '../common';

import { connectUserSupplierTypes, connectUserTypeOption } from 'constants/member/connect';
import { ConnectUserSupplierType, ConnectUserType } from 'types/member';

import * as S from './UserType.styled';

interface Props {
  userId: string;
  userType: ConnectUserType;
  userSupplierTypes: ConnectUserSupplierType[];
}

const UserType = ({ userId, userType, userSupplierTypes }: Props) => {
  const dispatch = useDispatch();

  const userTypeLoading = useSelector(selectConnectUserTypeLoading);

  const [currentUserType, setCurrentUserType] = useState<number>(userType);
  const [currentSupplierTypes, setCurrentSupplierTypes] =
    useState<ConnectUserSupplierType[]>(userSupplierTypes);

  const isSupplier = currentUserType === ConnectUserType.SUPPLIER;

  const onChangeUserType = ({
    target: { value },
  }: React.ChangeEvent<{ name?: string; value: unknown }>): void => {
    setCurrentUserType(Number(value));
    setCurrentSupplierTypes([]);
    dispatch(
      memberDetailActions.updateUserType({
        userId,
        type: Number(value),
        supplierTypes: [],
      }),
    );
  };

  const onChangeSupplierTypes = (supplierTypes: ConnectUserSupplierType[]) => {
    setCurrentSupplierTypes(supplierTypes);
    dispatch(
      memberDetailActions.updateUserType({
        userId,
        type: currentUserType,
        supplierTypes: supplierTypes,
      }),
    );
  };

  return (
    <S.UserTypeWrapper>
      <StatusDropdown
        optionList={connectUserTypeOption}
        currentValue={currentUserType}
        onChangeValue={onChangeUserType}
      />

      {isSupplier && (
        <S.SupplierTypeWrapper>
          <CheckboxGroup value={currentSupplierTypes} onChange={onChangeSupplierTypes}>
            {connectUserSupplierTypes.map(({ label, value }) => (
              <Checkbox key={label} label={label} value={value} checked={false} p={0.5} />
            ))}
          </CheckboxGroup>
        </S.SupplierTypeWrapper>
      )}

      {userTypeLoading && <CommonSpinner />}
    </S.UserTypeWrapper>
  );
};

export default UserType;
